export default __webpack_public_path__ + "static/media/seychelles.3f38d25f.svg";